"use strict";
/* eslint-disable object-curly-newline */

Object.defineProperty(exports, "__esModule", {
  value: true
}); // https://www.justice.gov/ust/eo/bapcpa/20220401/bci_data/median_income_table.htm

function getStateMedianFamilyIncome(dirtyState, persons) {
  if (!dirtyState) throw new Error("Missing State");
  var state = dirtyState.toUpperCase();
  if (!persons || persons === 0 || Number.isNaN(persons)) throw new Error("Missing Persons Count");
  var medianMap = {
    AK: {
      "1": 67010,
      "2": 90698,
      "3": 108072,
      "4": 108072
    },
    AL: {
      "1": 52138,
      "2": 63401,
      "3": 70250,
      "4": 85687
    },
    AR: {
      "1": 48882,
      "2": 61212,
      "3": 70169,
      "4": 71383
    },
    AZ: {
      "1": 58462,
      "2": 73262,
      "3": 79110,
      "4": 89741
    },
    CA: {
      "1": 65895,
      "2": 87355,
      "3": 97092,
      "4": 111535
    },
    CO: {
      "1": 70952,
      "2": 92321,
      "3": 100744,
      "4": 120898
    },
    CT: {
      "1": 72497,
      "2": 94528,
      "3": 108409,
      "4": 137128
    },
    DC: {
      "1": 74266,
      "2": 138342,
      "3": 138342,
      "4": 182068
    },
    DE: {
      "1": 65072,
      "2": 82516,
      "3": 96841,
      "4": 113626
    },
    FL: {
      "1": 55681,
      "2": 69884,
      "3": 75057,
      "4": 89206
    },
    GA: {
      "1": 55600,
      "2": 71504,
      "3": 79980,
      "4": 96622
    },
    GU: {
      "1": 45332,
      "2": 54202,
      "3": 61766,
      "4": 74744
    },
    HI: {
      "1": 75797,
      "2": 88181,
      "3": 100532,
      "4": 125304
    },
    IA: {
      "1": 54155,
      "2": 75139,
      "3": 85758,
      "4": 100901
    },
    ID: {
      "1": 54942,
      "2": 68818,
      "3": 76635,
      "4": 95031
    },
    IL: {
      "1": 61456,
      "2": 81190,
      "3": 97067,
      "4": 113649
    },
    IN: {
      "1": 54785,
      "2": 69505,
      "3": 81783,
      "4": 96083
    },
    KS: {
      "1": 55069,
      "2": 75845,
      "3": 88369,
      "4": 98454
    },
    KY: {
      "1": 51978,
      "2": 61790,
      "3": 71501,
      "4": 86508
    },
    LA: {
      "1": 49719,
      "2": 61042,
      "3": 71371,
      "4": 87472
    },
    MA: {
      "1": 75077,
      "2": 96358,
      "3": 117415,
      "4": 148713
    },
    MD: {
      "1": 75214,
      "2": 98840,
      "3": 113994,
      "4": 138054
    },
    ME: {
      "1": 57955,
      "2": 72988,
      "3": 87051,
      "4": 97141
    },
    MI: {
      "1": 56343,
      "2": 70163,
      "3": 84245,
      "4": 103838
    },
    MN: {
      "1": 65514,
      "2": 86358,
      "3": 106445,
      "4": 125753
    },
    MO: {
      "1": 53547,
      "2": 69614,
      "3": 80022,
      "4": 94774
    },
    MP: {
      "1": 30442,
      "2": 30442,
      "3": 35417,
      "4": 52091
    },
    MS: {
      "1": 47446,
      "2": 57148,
      "3": 61205,
      "4": 74888
    },
    MT: {
      "1": 57448,
      "2": 71836,
      "3": 79652,
      "4": 86867
    },
    NC: {
      "1": 53687,
      "2": 70000,
      "3": 76386,
      "4": 94269
    },
    ND: {
      "1": 58318,
      "2": 82635,
      "3": 94950,
      "4": 110225
    },
    NE: {
      "1": 53892,
      "2": 75719,
      "3": 91076,
      "4": 102544
    },
    NH: {
      "1": 75432,
      "2": 87260,
      "3": 113013,
      "4": 135833
    },
    NJ: {
      "1": 75321,
      "2": 92669,
      "3": 117697,
      "4": 140657
    },
    NM: {
      "1": 49757,
      "2": 60728,
      "3": 66183,
      "4": 70316
    },
    NV: {
      "1": 56949,
      "2": 73083,
      "3": 81179,
      "4": 88746
    },
    NY: {
      "1": 63548,
      "2": 80784,
      "3": 96854,
      "4": 117706
    },
    OH: {
      "1": 54877,
      "2": 70209,
      "3": 82734,
      "4": 100693
    },
    OK: {
      "1": 51435,
      "2": 66786,
      "3": 71397,
      "4": 83157
    },
    OR: {
      "1": 64975,
      "2": 77773,
      "3": 93773,
      "4": 106554
    },
    PA: {
      "1": 60640,
      "2": 74805,
      "3": 92441,
      "4": 110077
    },
    PR: {
      "1": 26146,
      "2": 26146,
      "3": 28484,
      "4": 33905
    },
    RI: {
      "1": 67541,
      "2": 84570,
      "3": 101104,
      "4": 114580
    },
    SC: {
      "1": 52348,
      "2": 67922,
      "3": 75128,
      "4": 90331
    },
    SD: {
      "1": 54821,
      "2": 74820,
      "3": 87475,
      "4": 96399
    },
    TN: {
      "1": 53188,
      "2": 66989,
      "3": 75394,
      "4": 91069
    },
    TX: {
      "1": 55441,
      "2": 74636,
      "3": 80733,
      "4": 93386
    },
    UT: {
      "1": 70425,
      "2": 77219,
      "3": 90629,
      "4": 101146
    },
    VA: {
      "1": 67918,
      "2": 86805,
      "3": 102869,
      "4": 121793
    },
    VI: {
      "1": 35968,
      "2": 43228,
      "3": 46090,
      "4": 50496
    },
    VT: {
      "1": 58728,
      "2": 78009,
      "3": 92628,
      "4": 117750
    },
    WA: {
      "1": 74398,
      "2": 90292,
      "3": 104644,
      "4": 118901
    },
    WI: {
      "1": 57934,
      "2": 76493,
      "3": 92586,
      "4": 109919
    },
    WV: {
      "1": 53244,
      "2": 58126,
      "3": 71757,
      "4": 78008
    },
    WY: {
      "1": 60510,
      "2": 76143,
      "3": 88902,
      "4": 106003
    }
  };
  return medianMap[state][persons > 4 ? 4 : persons] + (persons > 4 ? (persons - 4) * 9900 : 0);
}

exports.default = getStateMedianFamilyIncome; // Scraping helper script
// const states = {
//   AL: 'Alabama',
//   AK: 'Alaska',
//   AS: 'American Samoa',
//   AZ: 'Arizona',
//   AR: 'Arkansas',
//   CA: 'California',
//   CO: 'Colorado',
//   CT: 'Connecticut',
//   DE: 'Delaware',
//   DC: 'District Of Columbia',
//   FM: 'Federated States Of Micronesia',
//   FL: 'Florida',
//   GA: 'Georgia',
//   GU: 'Guam',
//   HI: 'Hawaii',
//   ID: 'Idaho',
//   IL: 'Illinois',
//   IN: 'Indiana',
//   IA: 'Iowa',
//   KS: 'Kansas',
//   KY: 'Kentucky',
//   LA: 'Louisiana',
//   ME: 'Maine',
//   MH: 'Marshall Islands',
//   MD: 'Maryland',
//   MA: 'Massachusetts',
//   MI: 'Michigan',
//   MN: 'Minnesota',
//   MS: 'Mississippi',
//   MO: 'Missouri',
//   MT: 'Montana',
//   NE: 'Nebraska',
//   NV: 'Nevada',
//   NH: 'New Hampshire',
//   NJ: 'New Jersey',
//   NM: 'New Mexico',
//   NY: 'New York',
//   NC: 'North Carolina',
//   ND: 'North Dakota',
//   MP: 'Northern Mariana Islands',
//   OH: 'Ohio',
//   OK: 'Oklahoma',
//   OR: 'Oregon',
//   PW: 'Palau',
//   PA: 'Pennsylvania',
//   PR: 'Puerto Rico',
//   RI: 'Rhode Island',
//   SC: 'South Carolina',
//   SD: 'South Dakota',
//   TN: 'Tennessee',
//   TX: 'Texas',
//   UT: 'Utah',
//   VT: 'Vermont',
//   VI: 'Virgin Islands',
//   VA: 'Virginia',
//   WA: 'Washington',
//   WV: 'West Virginia',
//   WI: 'Wisconsin',
//   WY: 'Wyoming',
// };
// function innerTextToNumber(str) {
//   return Number((str || '').replace(/[\D|,]/, '').replace(',', ''));
// }
// const unsorted = Array.from(document.querySelectorAll('table thead tr'))
//     .slice(3)
//     .map(r => ({
//       state: Object.keys(states).find(stKey => states[stKey] === Object.values(states).find(st => st.toUpperCase() === (r.querySelector('td:nth-of-type(1)') || {}).innerText)),
//       1: innerTextToNumber((r.querySelector('td:nth-of-type(2)') || {}).innerText),
//       2: innerTextToNumber((r.querySelector('td:nth-of-type(3)') || {}).innerText),
//       3: innerTextToNumber((r.querySelector('td:nth-of-type(4)') || {}).innerText),
//       4: innerTextToNumber((r.querySelector('td:nth-of-type(5)') || {}).innerText),
//     }))
//     .filter(obj => (obj.state || '').length)
//     .reduce((accum, obj) => ({
//       [obj.state]: {
//         1: obj[1],
//         2: obj[2],
//         3: obj[3],
//         4: obj[4],
//       },
//       ...accum,
//     }), {});
// Object.keys(unsorted)
//   .sort()
//   .reduce((acc, key) => {
//     acc[key] = unsorted[key];
//     return acc;
//   }, {});